<div class="popup-space">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="terms" *ngIf="data?.isTerms">
            <h2 mat-dialog-title>Notification</h2>
            <mat-dialog-content class="mat-typography">
              <h3 class="label-val2-new-line">Your session will expire in 5 minutes. Please click CONTINUE to remain logged in.</h3>

            </mat-dialog-content>

            <mat-dialog-actions align="center">
              <button mat-button type="button"  class="primary-button" (click)="closeDialog()">CONTINUE</button>
            </mat-dialog-actions>
          </div>
          <div class="terms" *ngIf="data?.isTerms == false">
            <h2 mat-dialog-title>Notification</h2>
            <mat-dialog-content class="mat-typography">
              <h3 class="label-val2-new-line">Your session has expired. Please click OK to return to the login page.</h3>

            </mat-dialog-content>

            <mat-dialog-actions align="center">
              <button mat-button  type="button" cdkFocusInitial class="primary-button" (click)="close()">ok</button>
            </mat-dialog-actions>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  
  
